import {Action, createReducer, on} from '@ngrx/store';
import {TrackEntity, TrackState} from '@spout/global-any/models';
import {getGlobalDefaultPaletteSelector} from '@spout/global-web/fns';
import {initialTrackState, trackAdapter} from '@spout/global-web/models';
import {authLoggedOut} from '../+account/auth.actions';
import {
  createProjectAction,
  createSongAction,
  createTrackAction
} from '../actions/create-entites.actions';
import {
  addTrack,
  addTracks,
  clearTracks,
  createTrack,
  deleteTrack,
  deleteTracks,
  syncTrackProgress,
  updateTrack,
  updateTracks,
  upsertTrack,
  upsertTracks
} from './track.actions';

function setDefaultColor(track: TrackEntity): TrackEntity {
  if (!track.color) {
    track.color = getGlobalDefaultPaletteSelector();
  }
  return track;
}

function setDefaultColorMany(tracks: TrackEntity[]): TrackEntity[] {
  return tracks.map((track: TrackEntity) => setDefaultColor(track));
}

const reducer = createReducer(
  initialTrackState,
  on(addTrack, (state, action) => {
    return trackAdapter.addOne(setDefaultColor(action.track), state);
  }),
  on(createProjectAction, (state, action) => {
    return trackAdapter.addOne(setDefaultColor(action.track), state);
  }),
  on(createSongAction, (state, action) => {
    return trackAdapter.addOne(setDefaultColor(action.track), state);
  }),
  on(createTrackAction, (state, action) => {
    return trackAdapter.addOne(setDefaultColor(action.track), state);
  }),
  on(upsertTrack, (state, action) => {
    return trackAdapter.upsertOne(setDefaultColor(action.track), state);
  }),
  on(addTracks, (state, action) => {
    return trackAdapter.addMany(setDefaultColorMany(action.tracks), state);
  }),
  on(upsertTracks, (state, action) => {
    return trackAdapter.upsertMany(setDefaultColorMany(action.tracks), state);
  }),
  on(updateTrack, (state, action) =>
    trackAdapter.updateOne(action.track, state)
  ),
  on(updateTracks, (state, action) =>
    trackAdapter.updateMany(action.tracks, state)
  ),
  on(deleteTrack, (state, action) => trackAdapter.removeOne(action.id, state)),
  on(deleteTracks, (state, action) =>
    trackAdapter.removeMany(action.ids, state)
  ),
  on(clearTracks, state => trackAdapter.removeAll(state)),

  on(createTrack, (state, action) => {
    return trackAdapter.addOne(action.track, state);
  }),
  on(authLoggedOut, (state, action) => {
    return trackAdapter.removeAll(state);
  }),
  on(syncTrackProgress, (state, action) => {
    return state;
  })
);

export function tracksReducer(state: TrackState | undefined, action: Action) {
  return reducer(state, action);
}
